export default "<app-header></app-header>\n<router-outlet></router-outlet>";